/**
 * @file atom plugin
 * @author cxtom(cxtom2008@gmail.com)
 */

/* eslint-disable
    fecs-indent, fecs-no-require, space-before-function-paren,
    semi, brace-style, quotes, operator-linebreak,
    fecs-arrow-body-style, fecs-use-method-definition,
    babel/object-curly-spacing
*/

const qs = require('querystring');
const RuleSet = require('webpack/lib/RuleSet');
const fs = require('fs-extra');

const id = 'atom-loader-plugin';
const NS = 'atom-loader';

class AtomLoaderPlugin {

  constructor(options = {}) {
    this.phpWriteToDisk = options.phpWriteToDisk || false;
  }

  emit (compilation) {
    const path = require('path');
    const options = compilation.compiler.options;
    const outputRoot = options.output.path;
    Object.keys(compilation.assets).forEach(function (name) {
      if (/\.php$/.test(name)) {
        const filePath = path.isAbsolute(name) ? name : path.resolve(outputRoot, name);
        fs.outputFileSync(filePath, compilation.assets[name].source());
      }
      if (/\.ssr\.js$/.test(name)) {
        const filePath = path.isAbsolute(name) ? name : path.resolve(outputRoot, name);
        fs.outputFileSync(filePath.replace('.ssr.js', '.js'), compilation.assets[name].source());
      }
    });
  }

  apply (compiler) {
    // add NS marker so that the loader can detect and report missing plugin
    if (compiler.hooks) {
      // webpack 4
      compiler.hooks.compilation.tap(id, compilation => {
        let normalModuleLoader
        if (Object.isFrozen(compilation.hooks)) {
          // webpack 5
          normalModuleLoader = require('webpack/lib/NormalModule').getCompilationHooks(compilation).loader
        } else {
          normalModuleLoader = compilation.hooks.normalModuleLoader
        }
        normalModuleLoader.tap(id, loaderContext => {
          loaderContext[NS] = true
        })
      })

      if (this.phpWriteToDisk) {
        compiler.hooks.afterEmit.tap(id, this.emit);
      }

    } else {
      // webpack < 4
      compiler.plugin('compilation', compilation => {
        compilation.plugin('normal-module-loader', loaderContext => {
          loaderContext[NS] = true
        })
        if (this.phpWriteToDisk) {
          compilation.plugin('afterEmit', this.emit)
        }
      })
    }

    // use webpack's RuleSet utility to normalize user rules
    const rawRules = compiler.options.module.rules
    const { rules } = new RuleSet(rawRules)

    // find the rule that applies to atom files
    let atomRuleIndex = rawRules.findIndex(createMatcher(`foo.atom`))
    if (atomRuleIndex < 0) {
      atomRuleIndex = rawRules.findIndex(createMatcher(`foo.atom.html`))
    }
    const atomRule = rules[atomRuleIndex]

    if (!atomRule) {
      throw new Error(
        `[AtomLoaderPlugin Error] No matching rule for .atom files found.\n` +
        `Make sure there is at least one root-level rule that matches .atom or .atom.html files.`
      )
    }

    if (atomRule.oneOf) {
      throw new Error(
        `[AtomLoaderPlugin Error] atom-loader 15 currently does not support atom rules with oneOf.`
      )
    }

    // get the normlized "use" for atom files
    const atomUse = atomRule.use
    // get atom-loader options
    const atomLoaderUseIndex = atomUse.findIndex(u => {
      return /^atom-loader|(\/|\\|@)atom-loader/.test(u.loader)
    })

    if (atomLoaderUseIndex < 0) {
      throw new Error(
        `[AomLoaderPlugin Error] No matching use for atom-loader is found.\n` +
        `Make sure the rule matching .atom files include atom-loader in its use.`
      )
    }

    // for each user rule (expect the atom rule), create a cloned rule
    // that targets the corresponding language blocks in *.atom files.
    const clonedRules = rules
      .filter(r => r !== atomRule)
      .map(cloneRule)

    // global pitcher (responsible for injecting template compiler loader & CSS
    // post loader)
    const pitcher = {
      loader: require.resolve('./loaders/pitcher'),
      resourceQuery: query => {
        const parsed = qs.parse(query.slice(1))
        return parsed.atom != null
      }
    }

    // replace original rules
    compiler.options.module.rules = [
      pitcher,
      ...clonedRules,
      ...rules
    ]
  }
}

function createMatcher (fakeFile) {
  return (rule, i) => {
    // #1201 we need to skip the `include` check when locating the atom rule
    const clone = Object.assign({}, rule)
    delete clone.include
    const normalized = RuleSet.normalizeRule(clone, {}, '')
    return (
      !rule.enforce &&
      normalized.resource &&
      normalized.resource(fakeFile)
    )
  }
}

function cloneRule (rule) {
  const { resource, resourceQuery } = rule
  // Assuming `test` and `resourceQuery` tests are executed in series and
  // synchronously (which is true based on RuleSet's implementation), we can
  // save the current resource being matched from `test` so that we can access
  // it in `resourceQuery`. This ensures when we use the normalized rule's
  // resource check, include/exclude are matched correctly.
  let currentResource
  const res = Object.assign({}, rule, {
    resource: {
      test: resource => {
        currentResource = resource
        return true
      }
    },
    resourceQuery: query => {
      const parsed = qs.parse(query.slice(1))
      if (parsed.atom == null) {
        return false
      }
      if (resource && parsed.lang == null) {
        return false
      }
      const fakeResourcePath = `${currentResource}.${parsed.lang}`
      if (resource && !resource(fakeResourcePath)) {
        return false
      }
      if (resourceQuery && !resourceQuery(query)) {
        return false
      }
      return true
    }
  })

  if (rule.oneOf) {
    res.oneOf = rule.oneOf.map(cloneRule);
  }

  return res
}

AtomLoaderPlugin.NS = NS;
module.exports = AtomLoaderPlugin;
